import React, {useEffect} from 'react';
import styles from './ToggleSwitch.module.scss';
interface ToggleProps {
  value: boolean;
  handleChange: (value: boolean) => void;
};
const ToggleSwitch = ({value, handleChange}: ToggleProps) => {
  return (
    <label className={styles.switch}>
        <input type="checkbox" onChange={() => handleChange(!value)} checked={value} />
        <span className={`${styles.slider} ${styles.round}`}></span>
    </label>
  );
};

export default ToggleSwitch;
